
import Draggable from 'vuedraggable'
import dashboardMasonry from '@/helpers/dashboardMasonry'
import {mapGetters, mapActions} from 'vuex'
import BreadcrumbsProject from '@/components/projectInformation/BreadcrumbsProject.vue'
import StepItem2 from '@/components/layout/StepItem2.vue'
import Loader from '@/components/layout/Loader.vue'
import DirectoryOverview from '@/components/projectInformation/DirectoryOverview.vue'
import PaymentPositionToVendor from '@/components/widgets/PaymentPositionToVendor.vue'
import PaymentPositionToClient from '@/components/widgets/PaymentPositionToClient.vue'
import NetCashPosition from '@/components/widgets/NetCashPosition.vue'
import TotalTradesProcured from '@/components/widgets/TotalTradesProcured.vue'
import ProcurementDetails from '@/components/widgets/ProcurementDetails.vue'
import CummulativePaymentPosition from '@/components/widgets/CummulativePaymentPosition.vue'
import PurchaseOrdersList from '@/components/widgets/PurchaseOrdersList.vue'
import ClientInvoiceList from '@/components/widgets/ClientInvoiceList.vue'
import ClientProgressClaims from '@/components/widgets/ClientProgressClaims.vue'
import ChangeRequestList from '@/components/widgets/ChangeRequestList.vue'
import ProjectBudgetBreakdown from '@/components/widgets/ProjectBudgetBreakdown.vue'
import ProjectInformationWidget from '@/components/widgets/ProjectInformationWidget.vue'
import ProjectDates from '@/components/widgets/ProjectDates.vue'
import BillOfQuanitityListWidget from '@/components/widgets/BillOfQuanitityListWidget.vue'
import ProjectQuotationListWidget from '@/components/widgets/ProjectQuotationListWidget.vue'
import NotificationWidget from '@/components/widgets/NotificationWidget.vue'
import ActionablesWidget from '@/components/widgets/ActionablesWidget.vue'
import ProjectOverviewWidget from '@/components/widgets/ProjectOverviewWidget.vue'
import {GetSystemSettings, GetTokenSharepointFromAuth,GetProjectSharepointFolders, UpdateProjectSharepointFolders } from '@/actions/projectActions.js'
import {GetMyUserDashboarSettings , UpsertMyUserDashboarSettings} from '@/actions/userActions.js'
import { stageIcons, LinkList, ModuleActionList, ApprovalStageBoqObj, ReformatNumber ,CleanSharePointFilename } from '@/helpers/utilities.js'
import  *  as msalHelper  from '@/helpers/msalHelpers.js'
import Modal from '@/components/layout/Modal.vue'
import { Modal as BootstrapModal } from 'bootstrap'
import { markRaw } from 'vue';
import 'dotenv/config'
import {CreateBoq, AddQuotation} from '@/actions/boqActions.js'

// Only persisted layout values count as edits; component metadata and loading do not.
function DashboardLayoutSignature(settings){
    return JSON.stringify(settings.map(setting => [
        String(setting.widgetId),
        Number(setting.width) || 0,
        Number(setting.height) || 1
    ]))
}

export default {
    name : 'Overiew',
    directives: { dashboardMasonry },
    components : {
        StepItem2,
        Draggable,Loader,
        BreadcrumbsProject,Modal,
        DirectoryOverview,PaymentPositionToVendor, PaymentPositionToClient, NetCashPosition, TotalTradesProcured,
        ProcurementDetails, CummulativePaymentPosition, PurchaseOrdersList, ClientInvoiceList, ClientProgressClaims,
        ChangeRequestList, ProjectBudgetBreakdown, ProjectInformationWidget, ProjectDates,BillOfQuanitityListWidget,
        ProjectQuotationListWidget, NotificationWidget,ActionablesWidget,ProjectOverviewWidget
        
    },
    data(){

        

        return{
            editMode : false,
            dashboardSettings : {
                settings : []
            },
            widgetList : [
                { id : 1 , name : 'Notification', component : markRaw(NotificationWidget), presetWidth : 6,  },
                { id : 2 , name : 'Actionables', component : markRaw(ActionablesWidget), presetWidth : 6 },
                { id : 19 , name : 'Project Overview', component : markRaw(ProjectOverviewWidget), presetWidth : 12 },
                { id : 3 , name : 'Vendor Payment Position', component : markRaw(PaymentPositionToVendor), presetWidth : 4 },
                { id : 4 , name : 'Client Payment Position', component : markRaw(PaymentPositionToClient), presetWidth : 4 },
                { id : 5 , name : 'Net Cash Position', component : markRaw(NetCashPosition), presetWidth : 4 },
                { id : 6 , name : 'Procurement Performance', component : markRaw(TotalTradesProcured), presetWidth : 6 },
                { id : 7 , name : 'Project Schedule', component : markRaw(ProjectDates), presetWidth : 6 },
                { id : 8 , name : 'Procurement Progress', component : markRaw(ProcurementDetails), presetWidth : 6 },
                { id : 9 , name : 'Cummulative Payment Position', component : markRaw(CummulativePaymentPosition), presetWidth : 6 },
                { id : 10 , name : 'Total Budget Breakdown', component : markRaw(ProjectBudgetBreakdown), presetWidth : 6 },
                { id : 11 , name : 'Directory', component : markRaw(DirectoryOverview), presetWidth : 6 },
                { id : 12 , name : 'Project Information', component : markRaw(ProjectInformationWidget), presetWidth : 6 },
                { id : 13 , name : 'Bill of Quantities', component : markRaw(BillOfQuanitityListWidget), presetWidth : 6 },
                { id : 14 , name : 'Quotation', component : markRaw(ProjectQuotationListWidget) },
                { id : 15 , name : 'Purchase Order', component : markRaw(PurchaseOrdersList), presetWidth : 6 },
                { id : 16 , name : 'Client Progress Claims', component : markRaw(ClientProgressClaims), presetWidth : 6 },
                { id : 17 , name : 'Client Invoices', component : markRaw(ClientInvoiceList), presetWidth : 6 },
                { id : 18 , name : 'Change Request', component : markRaw(ChangeRequestList), presetWidth : 6 },
            ],
            directoryOverviewLoader: true,
            projectOverviewLoader: true,
            boqOverviewLoader: true,
            quotationLoader: true,
            placeHolderOverviewLoader: true,
            stages : stageIcons,
            boqData : [],
            quotationData : [],
            boqUrl : process.env.VUE_APP_BOQ_URL,
            projectId : this.$route.params.id,
            ModuleActionList : ModuleActionList,
            ApprovalStageBoqObj : ApprovalStageBoqObj,
            ReformatNumber : ReformatNumber,
            newQuotation  : {},
            qtnSaveClicked : false,
            isExecuting : false,
            newBoq : { name : '' },
            boqSaveClicked : false,
            projectSettings : {},
            sharepointToken : null,
            sharepointFolders : {},
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            updateWidgetObj : {},
            selectedWidgets : [],
            draftSelectedWidgets : [],
            draftWidgetWidth : null,
            isWidgetSaving : false,
            savedDashboardLayout : null
        }
    },
    methods :{
        ...mapActions(['GetProjectInfo','GetProjectDirectory','ChangeActiveLink']),
        OpenWidgetList(){
            this.draftSelectedWidgets = [...this.selectedWidgets]
            this.draftWidgetWidth = null
        },
        CheckWidget(id){
            const self = this
            const getIndex = self.draftSelectedWidgets.indexOf(id)
            if(getIndex==-1){
                self.draftSelectedWidgets.push(id)
            }
            else{
                self.draftSelectedWidgets.splice(getIndex,1)
            }
        },
        CancelWidgetList(){
            this.draftSelectedWidgets = [...this.selectedWidgets]
            this.draftWidgetWidth = null
        },
        ApplyWidgetList(){
            const self = this
            const selectedIds = [...new Set(self.draftSelectedWidgets)]
            const bulkWidth = [3, 6, 12].includes(Number(self.draftWidgetWidth))
                ? Number(self.draftWidgetWidth) : null
            if(selectedIds.length==0){
                self.$swal('Widget List', 'Please select atleast one Widget', 'warning')
                return
            }

            const selectedIdSet = new Set(selectedIds)
            const currentSettings = Array.isArray(self.dashboardSettings.settings) ? self.dashboardSettings.settings : []
            const nextSettings = currentSettings
                .filter(setting => selectedIdSet.has(setting.widgetId))
                .map(setting => {
                    const getWidget = self.widgetList.find(u=>u.id==setting.widgetId)
                    if(!getWidget){ return null }
                    return {
                        ...setting,
                        height : setting.height || 1,
                        width : bulkWidth || setting.width || getWidget.presetWidth || 6,
                        component : getWidget.component,
                        name : getWidget.name
                    }
                })
                .filter(Boolean)

            for(let x = 0; x < selectedIds.length; x++){
                const id = selectedIds[x]
                if(nextSettings.find(u=>u.widgetId==id)){ continue }
                const getWidget = self.widgetList.find(u=>u.id==id)
                if(!getWidget){ continue }
                nextSettings.push({
                    position : nextSettings.length + 1,
                    height : 1,
                    width : bulkWidth || getWidget.presetWidth || 6,
                    widgetId : getWidget.id,
                    component : getWidget.component,
                    name : getWidget.name
                })
            }

            for(let i = 0 ; i < nextSettings.length ; i++){
                nextSettings[i].position = i + 1
            }
            self.dashboardSettings.settings = nextSettings
            self.selectedWidgets = selectedIds
            self.draftSelectedWidgets = [...selectedIds]
            self.$refs.closeModalOpenWidgets.click()
        },
        RemoveWidget(widgetId){
            const self = this
            const currentSettings = Array.isArray(self.dashboardSettings.settings) ? self.dashboardSettings.settings : []
            if(currentSettings.length<=1){
                self.$swal('Widget List', 'Please keep at least one Widget', 'warning')
                return
            }

            self.dashboardSettings.settings = currentSettings
                .filter(setting => String(setting.widgetId) !== String(widgetId))
                .map((setting, index) => ({
                    ...setting,
                    position : index + 1
                }))
            self.selectedWidgets = self.selectedWidgets.filter(id => String(id) !== String(widgetId))
            self.draftSelectedWidgets = self.draftSelectedWidgets.filter(id => String(id) !== String(widgetId))
        },
        SetUpProject(){
            const self = this
            if(!self.sharepointFolders.projectSharepointFolders && !self.sharepointToken){
                location.href = process.env.VUE_APP_REST_MAIN_API + '/api/auth/token/email?type=2&returnUrl='+encodeURIComponent(window.location.href)
            }
        },
        OpenUpdateWidget(id,width,height){
            this.updateWidgetObj.id = id
            this.updateWidgetObj.width = width
            this.updateWidgetObj.height = height
            this.$nextTick(()=>{
                const modalElement = document.getElementById('ModalUpdateWidget')
                if(!modalElement){ return }
                BootstrapModal.getOrCreateInstance(modalElement).show()
            })
        },
        UpdateSettings(){
            const self = this
            const widgetSize = self.updateWidgetObj
            const getSettingsWidget = self.dashboardSettings.settings.find(u=>u.widgetId==widgetSize.id)
            if(!getSettingsWidget){ return }
            const normalizedWidth = Number(widgetSize.width)
            if(![3, 6, 12].includes(normalizedWidth)){ return }
            getSettingsWidget.width = normalizedWidth
            getSettingsWidget.height = widgetSize.height

            self.$refs.closeModalUpdateWidget.click()
        },
        async SaveSettings(){
            const self = this
            if(self.isWidgetSaving){ return }
            
            if(self.selectedWidgets.length==0){
                self.$swal('Save Dashboard', 'Please select atleast one Widget', 'warning')
                return
            }
            
            self.isWidgetSaving = true
            const settings = self.dashboardSettings.settings.map((setting, index) => ({
                ...setting,
                position : index + 1
            }))
            const submittedLayout = DashboardLayoutSignature(settings)
            try{
                const saved = await UpsertMyUserDashboarSettings({ settings })
                if(saved!='OK'){
                    self.$swal('Save Dashboard', saved, 'warning')
                    return
                }
                self.savedDashboardLayout = submittedLayout
                self.editMode = self.haveChanges
                self.$swal('Save Dashboard', self.haveChanges
                    ? 'The submitted layout was saved. You have additional unsaved changes.'
                    : 'Dashboard successfully saved!', self.haveChanges ? 'info' : 'success')
            }catch{
                self.$swal('Save Dashboard', 'The dashboard could not be saved. Please try again.', 'warning')
            }finally{
                self.isWidgetSaving = false
            }
        },
        CreateBoq(){
            const self = this
            self.boqSaveClicked = true

            if(self.isExecuting){
                return
            }

            const name = self.newBoq.name.trim()
            if(!name){
                return
            }
            const newData = {
                name,
                projectId : self.projectInfo._id,
                currencyId : self.projectInfo.currencyId._id
            }
            self.isExecuting = true

            CreateBoq(newData).then((res)=>{
                self.isExecuting = false
                if(res.status!=200){
                    self.$swal('Add BoQ',res.data,'warning')
                }else{
                    // Open the newly created BOQ in the BOQ Builder page.
                    window.location.href = self.boqUrl + '/boq/builder/' + res.data
                }
            })
        },
        CreateQuotation(e){
            const btn = e.target
            const self = this
            self.qtnSaveClicked = true

            if(self.isExecuting){
                return
            }
            const data = self.newQuotation

            if(!data.qtnName || !data.qtnNumber){
                return
            }
            data.projectId = self.projectInfo._id
            self.qtnSaveClicked = false
            btn.disabled = true
            self.isAdding = true
            AddQuotation(data).then((res)=>{
                if(res.status!=200){
                    
                    self.isAdding = false
                    btn.disabled = false
                    self.$swal('Add Quotation',res.data,'warning')
                }else{
                    window.location.href = self.boqUrl + '/boq/' + res.data + '/quotation/item?isEdit=true'
                }
            })
        },
        
    },
    computed : {
        ...mapGetters(['projectInfo','projectUpdateObject', 'permission']),
        haveChanges(){
            return this.savedDashboardLayout !== null
                && DashboardLayoutSignature(this.dashboardSettings.settings) !== this.savedDashboardLayout
        }
    },
    mounted :async function () {
        const self = this
        self.ChangeActiveLink(LinkList.SUMMARY)
        const projectId = self.$route.params.id
        await self.GetProjectInfo(projectId).catch()
        self.projectOverviewLoader = false
        await self.GetProjectDirectory().catch()
        self.directoryOverviewLoader = false

        const getDasboard = await GetMyUserDashboarSettings()
        if(getDasboard){
            self.dashboardSettings= getDasboard
        }else{
            let presetDasboardSettings = []
            for(let x = 0; x < self.widgetList.length; x++){
                const getWidget = self.widgetList[x]
                presetDasboardSettings.push({
                    position : x,
                    height : 1,
                    width : getWidget.presetWidth,
                    widgetId : getWidget.id, 
                })
            }
            self.dashboardSettings.settings = presetDasboardSettings
        }

        //set the components
        for(let x = 0; x< self.dashboardSettings.settings.length; x++){
            const getSettings = self.dashboardSettings.settings[x]
            const getWidget = self.widgetList.find(u=> u.id==getSettings.widgetId)
            if(!getWidget) { continue }
            getSettings.width = getSettings.width || getWidget.presetWidth || 6
            getSettings.height = getSettings.height || 1
            getSettings.component = getWidget.component
            getSettings.name = getWidget.name
            self.selectedWidgets.push(getSettings.widgetId)
        }
        self.savedDashboardLayout = DashboardLayoutSignature(self.dashboardSettings.settings)

        // Background SharePoint setup must not mark the layout dirty or clear user edits.
        try{
            self.projectSettings = await GetSystemSettings() || {}
            self.sharepointToken = await GetTokenSharepointFromAuth()
            const sharepointFolders = await GetProjectSharepointFolders(projectId)
            self.sharepointFolders = sharepointFolders || {}
            if(sharepointFolders && self.sharepointToken && !sharepointFolders.projectSharepointFolders && self.projectSettings.sharepointDriveId){
                const projectFolder = await msalHelper.CreateFolderToDrive(self.sharepointToken,self.projectSettings.sharepointDriveId,CleanSharePointFilename(self.projectInfo.projectNumber + ' ' + self.projectInfo.projectName))
                const qtnFolder = await msalHelper.CreateFolderToFolder(self.sharepointToken,self.projectSettings.sharepointDriveId,projectFolder.id,'Quotation')
                const poFolder = await msalHelper.CreateFolderToFolder(self.sharepointToken,self.projectSettings.sharepointDriveId,projectFolder.id,'Purchase Order')
                const viFolder = await msalHelper.CreateFolderToFolder(self.sharepointToken,self.projectSettings.sharepointDriveId,projectFolder.id,'Vendor Invoice')
                await UpdateProjectSharepointFolders({
                    projectId : projectId,
                    projectFolderId : projectFolder.id,
                    quotationFolderId : qtnFolder.id,
                    purchaseOrderFolderId : poFolder.id,
                    vendorInvoiceFolderId : viFolder.id,
                })
            }
        }catch{
            console.warn('Dashboard SharePoint setup could not be completed.')
        }finally{
            self.placeHolderOverviewLoader = false
        }
        
    }
}
